import { Dialog } from '@material-ui/core';
import Form, { InputType } from '../../lib/Formik';
import {
    ONE_SPECIAL_CHARACTER,
    PasswordGuidelines,
    UPPER_CASE_LOWER_CASE,
    WHITESPACE,
} from '../../lib/PasswordGuidelines';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import * as yup from 'yup';
import { SetPasswordPayload } from '../../redux-store/types/login';
import { connect } from 'react-redux';
import { onSetPassword } from '../../redux-store/actions/login';
import { useEffect, useState } from 'react';
import { OTP_ACTIONS } from '../../utils/constants';

const { setPassword, common, passwordGuidelines } = en;

interface FormFieldProps {
    displayName: string;
    confirmPassword: string;
    password: string;
}

const formFields: Partial<InputType>[] = [
    {
        label: setPassword.displayName,
        name: 'displayName',
        type: 'text',
    },
    {
        label: setPassword.setPassword,
        name: 'password',
        type: 'password',
    },
    {
        label: setPassword.confirmPassword,
        name: 'confirmPassword',
        type: 'password',
    },
    {
        component: PasswordGuidelines,
        name: 'password',
    },
];

const initialValues: FormFieldProps = {
    displayName: '',
    confirmPassword: '',
    password: '',
};

const validationSchema = yup.object({
    displayName: yup.string().required(common.errors.displayname.required),
    // .matches(/^[A-Za-z0-9 ]+$/, common.errors.displayname.noSpecialCharacters), // Need to allow Special Charcters
    password: yup
        .string()
        .required(common.errors.password.setPassword)
        .min(8, passwordGuidelines.one)
        .test(
            passwordGuidelines.one,
            passwordGuidelines.one,
            (value = '') => !WHITESPACE.test(value),
        )
        .matches(UPPER_CASE_LOWER_CASE, passwordGuidelines.two)
        .matches(ONE_SPECIAL_CHARACTER, passwordGuidelines.three),
    confirmPassword: yup.string().required(common.errors.password.confirmPassword),
});

function SetPassword(props: any) {
    const { otpRef, reqId, pan, pekrn } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('signin');
        }
    }, []);

    const onSave = async (values: FormFieldProps, action: FormikHelpers<FormFieldProps>) => {
        const payload: SetPasswordPayload = {
            otpRef,
            reqId,
            displayName: values.displayName,
            password: values.password,
            action: OTP_ACTIONS.register,
        };
        try {
            let res = await props.onSetPassword(payload);
            props.history.push('/signup-questionnaire', {
                reqId,
                otpRef,
                displayName: values.displayName,
                password: values.password,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
        action.setSubmitting(false);
    };

    const validate = (values: FormFieldProps) => {
        if (values.password !== values.confirmPassword) {
            return {
                confirmPassword: common.errors.password.confirmPasswordError,
            };
        }
    };

    const formik = useFormik({
        initialValues,
        onSubmit: onSave,
        validate: validate,
        validationSchema,
        validateOnChange: true,
    });
    return (
        <>
            <div className="signup-padding">
                <div className="signup-progress">
                    <span></span>
                    <span className="active"></span>
                    <span></span>
                </div>
                <h4 className="text-center">{setPassword.heading}</h4>
                <p className="text-center signup-userid subheading">
                    {`${setPassword.disclimer.t1} ${pan ? 'PAN' : 'PEKRN'} ${setPassword.disclimer.t2
                        }`}
                </p>
                <Form
                    ui={formFields}
                    submitButtonLabel={setPassword.action.continue}
                    formik={formik}
                />
            </div>
        </>
    );
}

export default connect(null, { onSetPassword })(SetPassword);
